import { Component, OnInit } from '@angular/core';
import { ContentService } from '../core/services/content.service';
import { NotificationService } from '../core/services/notification.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Attributes } from '../core/models/Strapi';
import { GeneralData } from '../core/models/General';

@Component({
    selector: 'app-help-page',
    templateUrl: './help-page.component.html',
    styleUrls: ['./help-page.component.scss'],
    standalone: false
})
export class HelpPageComponent implements OnInit {
  general?: Attributes<GeneralData>;
  userUid = '';

  constructor(
    private contentService: ContentService,
    private notificationService: NotificationService,
    private afAuth: AngularFireAuth,
  ) {}

  ngOnInit() {
    this.contentService.getGeneral().subscribe((r) => {
      this.general = r.data.attributes;
    });
    this.afAuth.user.subscribe((user) => {
      this.userUid = user.uid;
    });
  }

  sendNotification() {
    this.notificationService.requestPermission();
  }
}
